<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

const props = defineProps({
  item: {
    type: Object,
    default: () => ({})
  },
});

const store = useStore();
const route = useRoute();
const menuOpen = ref(true);
const pcHeaderOpen = computed(() => store.state.menuVisible)

const checkActiveRoute = (item) => {
  if (item.to === '') return false;
  const path = typeof item.to === 'object' && 'value' in item.to ? item.to.value : item.to;
  if (item.exact) {
    return route.path === path;
  }
  return route.path === path || route.path.startsWith(path + '/');
};

const clickMenuToggle = () => {
  // pc 에서 메뉴가 닫힌 상태에서는 toggle 동작 안 함
  if (pcHeaderOpen.value) {
    menuOpen.value = !menuOpen.value
  }
}

</script>

<template>
  <li class="nav-item-wrap">
    <div :class="['nav-item', { 'select': checkActiveRoute(item) }]">
      <button v-if="item.children" class="nav-item-link" @click="clickMenuToggle">
        <i v-if="item.icon" class="nav-item-icon pi" :class="item.icon"></i>
        <span class="nav-item-label">{{ item.label }}</span>
        <i class="nav-item-toggle pi pi-angle-down" :class="{'open' : menuOpen}"></i>
      </button>
      <router-link
        v-else
        class="nav-item-link"
        :to="item.to"
        :class="{disabled: item.to === ''}"
      >
        <i v-if="item.icon" class="nav-item-icon pi" :class="item.icon"></i>
        <span class="nav-item-label">{{ item.label }}</span>
      </router-link>
    </div>
    <template v-if="item.children && item.visible !== false">
      <ul :class="['app-nav sub', { 'open' : menuOpen }]">
        <app-menu-item v-for="(child, i) in item.children" :key="i" :item="child"></app-menu-item>
      </ul>
    </template>
  </li>
</template>
